<template>
    <div class="brand-tester-page">
        <BrandTool :active-tab="3">
            <div class="brand-tester">
                <p class="body-copy">
                    So you want to run a consumer test for that brand name you’ve created? See if it’s something that
                    resonates with your target audience/consumer?  That’s what Khonsu Consumer Test is for. We will be
                    partnering with a consumer research company who can do all your testing for you.
                </p>

                <p class="body-copy">
                    They’ll figure out a proposal that’s right for you based on the size of your budget and the number of
                    respondents you want, the key demographics etc.
                </p>

                <p class="body-copy">
                    After a few prompts to establish what you want, your details will be picked up by our consumer research
                    partner and they’ll take it from there, keeping you in the loop all the way and up to delivery of your
                    consumer research results.
                </p>
            </div>
        </BrandTool>
    </div>
</template>

<script setup>
    import BrandTool from "@/components/layout/BrandTool";
</script>